import { catchError, forkJoin, Observable, of } from "rxjs";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { URLConfig } from "../network/urlStore";
import {
  ITreatmentProduct,
  ITreatmentProductAllResponse,
} from "../models/ITreatmentProdcuts.model";
import { IProductAttributesAllResponse, IStatusAllResponse } from "../models";

export const getTreatmentProducts = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITreatmentProductAllResponse> => {
  let url = URLConfig.getTreatmentProductsMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITreatmentProductAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching treatment Products data", error);
      }
    );
  });
};
export const getTreatmentProductsNextPage = (
  nextPageURI: string
): Observable<ITreatmentProductAllResponse> => {
  let url = URLConfig.getTreatmentProductsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (treatmentProductResponse) => {
        if (treatmentProductResponse) {
          const treatmentProductsResponse =
            treatmentProductResponse as unknown as ITreatmentProductAllResponse;
          subscriber.next(treatmentProductsResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Treatment Products data", error);
      }
    );
  });
};

export const getContentLengthForTreatmentProducts = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getTreatmentProductsMasterDataURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        console.log(res);
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log(
          "Error while fetching treatment products master data:",
          error
        );
      });
  });
};

export const createTreatmentProducts = (
  requestPayload: any
): Observable<any> => {
  let url = URLConfig.getTreatmentProductsMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (treatmentProductResponse) => {
        if (treatmentProductResponse) {
          const treatmentProductsResponse =
            treatmentProductResponse as unknown as ITreatmentProductAllResponse;
          subscriber.next(treatmentProductsResponse);
        }
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a Treatment Products", error);
      }
    );
  });
};

export const updateTreatmentProducts = (
  treatmentProduct: any,
  treatmentProductId: string
): Observable<any> => {
  let url = URLConfig.updateTreatmentProductsMasterDataURL(treatmentProductId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, treatmentProduct).then(
      (res) => {
        const response = res as unknown as ITreatmentProduct;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating treatmentProduct", error);
      }
    );
  });
};
export const deleteTreatmentProduct = (
  treatmentProductId: string,
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: boolean[] | string[];
  }>
): Observable<any> => {
  let url = URLConfig.updateTreatmentProductsMasterDataURL(treatmentProductId);
  
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating treatmentProduct", error);
      }
    );
  });
};

export const getTreatmentProductParentType = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<Array<{ value: string; label: string }>> => {
  let url = URLConfig.getTreatmentProductParentTypeURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (treatmentProductParentTypeResponse: unknown) => {
        if (treatmentProductParentTypeResponse) {
          const res =
            treatmentProductParentTypeResponse as unknown as IStatusAllResponse;

          const productParentTypeList = res.values.map((item: string) => ({
            value: item,
            label: item,
          }));

          subscriber.next(productParentTypeList);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log(
          "Error while fetching Treatment Product Parent Type data",
          error
        );
      }
    );
  });
};

export const getTreatmentProductType = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<Array<{ value: string; label: string }>> => {
  let url = URLConfig.getTreatmentProductTypeURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (treatmentProductTypeResponse: unknown) => {
        if (treatmentProductTypeResponse) {
          const res =
            treatmentProductTypeResponse as unknown as IStatusAllResponse;

          const productTypeList = res.values.map((item: string) => ({
            value: item,
            label: item,
          }));

          subscriber.next(productTypeList);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Treatment Product Type data", error);
      }
    );
  });
};

export const getTreatmentProductUnit = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<Array<{ value: string; label: string }>> => {
  let url = URLConfig.getTreatmentProductUnitURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (treatmentProductUnitResponse: unknown) => {
        if (treatmentProductUnitResponse) {
          const res =
            treatmentProductUnitResponse as unknown as IStatusAllResponse;

          const productsUnitList = res.values.map((item: string) => ({
            value: item,
            label: item,
          }));

          subscriber.next(productsUnitList);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while Treatment Product Unit data", error);
      }
    );
  });
};

export const combineTreatmentProducts = (selectedProducts: {}, queryParams?: Array<{
  key: AgTechQueryParam;
  value: boolean[] | string[];
}>): Observable<any> => {

  let deleteRequestsObservableList: Observable<any>[] = [];

  deleteRequestsObservableList = Object.keys(selectedProducts).map((productId) => 
    deleteTreatmentProduct(productId, queryParams).pipe(
      catchError((error: any) => {
        return of({ error, productId });
      })
    )
  );

  if (deleteRequestsObservableList.length > 0) {
    return new Observable((subscriber) => {
      forkJoin(deleteRequestsObservableList).subscribe({
        next: (response: (ITreatmentProduct | { error: any; productId: string })[]) => {
          subscriber.next(response);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
        },
        complete: () => {
          console.info("complete");
        },
      });
    });
  }
  return of([]);
};

export const getProductAttributes = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IProductAttributesAllResponse> => {
  let url = URLConfig.getProductsAttributeMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (productResponse: unknown) => {
        if (productResponse) {
          const productsResponse =
            productResponse as unknown as IProductAttributesAllResponse;
          subscriber.next(productsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log(
          "Error while fetching products attribute master data",
          error
        );
      }
    );
  });
};

export const updateEnableTreatmentProduct = (
  productPayload: any,
  treatmentProductId: string
): Observable<any> => {
  let url = URLConfig.updateTreatmentProductsMasterDataURL(treatmentProductId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, productPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating field", error);
      }
    );
  });
};

// New bulk update API for EnabledForOnFarm checkbox selection
export const patchEnableOnFarmTreatmentProducts = (
  patchPayload: {
    Patches: Array<{
      Id: number;
      UpdateObjects: Array<{
        op: string;
        path: string;
        value: boolean;
      }>;
    }>;
  },
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.patchEnableOnFarmTreatmentProductsMasterDataURL();
  
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.patch(url, patchPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while bulk updating treatment products", error);
      }
    );
  });
};

export const patchFilteredUpdateTreatmentProducts = (
  requestPayload: {
    columnName: string;
    newValue: string | boolean;
  },
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.patchFilteredUpdateTreatmentProductsMasterDataURL();
  
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while filtered updating treatment products", error);
      }
    );
  });
};